import { IInputsProgress, IInputStatus } from '../../../interface/progress.interface'


const isFullStep = (inputs: IInputsProgress) => {
  const isFull = Object.keys(inputs).every((input: any) => {
    console.log(input.status)
    return (input.status === IInputStatus.success || input.status === IInputStatus.disabled)
  })
  return isFull
}

export default isFullStep